import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
const spin = keyframes `
  100% {
    transform: rotate(360deg);
  }
`;
const Spinner = styled.svg `
  height: ${({ height }) => `${height || 40}px`};
  width: ${({ width }) => `${width || 40}px`};
  animation: ${spin} 0.8s linear infinite;
`;
export function FullSpinner(props) {
    // First div is used when using nextjs/dynamic even after component is loaded
    return (_jsx("div", { style: { height: '100%' }, children: _jsx("div", { style: {
                display: 'flex',
                height: '100%',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
            }, children: _jsxs(Spinner, { ...props, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { style: { opacity: 0.25 }, cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { style: { opacity: 0.75 }, fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] }) }) }));
}
//# sourceMappingURL=FullSpinner.js.map